import React from 'react'

import styles from './LevelUpCard.module.scss'
import { LevelUpType } from 'store/services/Library/Library.types'

type LevelUpCardProps = {
  levelUpType: LevelUpType
  tabIndex?: number
  itemRef?: (element: HTMLElement | null) => HTMLElement | null
  onClick: () => void
  onFocus?: () => void
}

const LEVEL_UP_ITEMS = [
  {
    title: 'Word Craft',
    levelUpType: LevelUpType.WORD_CRAFT,
    img: 'images/wordcraft.png'
  },
  {
    title: 'Sentence Builder',
    levelUpType: LevelUpType.SENTENCE_BUILDER,
    img: 'images/sentence_builder.png'
  },
  {
    title: 'Pronunciation',
    levelUpType: LevelUpType.PRONUNCIATION,
    img: 'images/sentence_builder.png'
  }
]

export function LevelUpCard({ onClick, levelUpType, itemRef, tabIndex, onFocus }: LevelUpCardProps) {
  const item = LEVEL_UP_ITEMS.find((i) => i.levelUpType === levelUpType)

  if (!item) return null

  const { img, title } = item

  return (
    <button
      type="button"
      className={styles.card}
      onClick={onClick}
      aria-label={`Level up activity: ${title}`}
      ref={itemRef}
      tabIndex={tabIndex}
      onFocus={onFocus}
    >
      <div className={styles.itemContainer} style={{ backgroundImage: `url(${img})` }}>
        <div className={styles.bottomShadow}>
          <img src={img} alt="" className={styles.bgImg} />
          <div className={styles.bgImgShadow} />
        </div>

        <div className={styles.content}>
          <div className={styles.textContainer}>
            <span className={styles.smallText}>Level up!</span>
            <span className={styles.title}>{title}</span>
          </div>
        </div>
      </div>
    </button>
  )
}
